import React from 'react'
import styled from 'styled-components'

import FeatherIconWrapper from '../../../Icons/FeatherIconWrapper'


/*
 *  @Description:   Stateless component that presents an Icon with a description.
 *                   
 *                  The element can be clickable in order to execute a method, just pass to this the onClick prop.
 */

const TextSpan = styled.span`
    margin-left: 8px;
    cursor: pointer;
    &.noDisplay{
        display: inline-block
    }
    &.reducedText{
        display:none
    }
    @media (max-width: 1030px) {
        &.noDisplay{ 
            display: none;
        }
        &.reducedText{
            display: inline-block;
        }
    }
`;

const StyledDiv = styled.div`
    min-height: 25px;  
    margin: 15px 15px 0 0;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
`;

const InformationItem = ( {
                              Icon,
                              text,
                              reducedText,
                              fillColor,
                              isFilled,
                              onClick,
                              color,
                              isResource,
                              alwaysShowText
                          } ) => {
    return (
        <StyledDiv
            onClick={ onClick }>
            <FeatherIconWrapper
                color={ color }
                width="18px"
                fillColor={ isFilled ? fillColor : "none" }
                iconStyle="padding:0; stroke-width: 2px; flex-shrink: 0; width: 18px;"
                Icon={ Icon }
            />
            <TextSpan className={ alwaysShowText ? "" : "noDisplay" }>{ text }</TextSpan>
            <TextSpan className={ "reducedText" }>{ reducedText }</TextSpan>
        </StyledDiv>
    )
};


export default InformationItem;